<template>
  <div class="banner">
    <div class="video-wrap">
      <video autoplay loop class="video" muted v-on:canplay="canplay">
        <source src="../../../assets/img/mp4.mp4" type="video/mp4"/>
      </video>
      <div class="inner">
        <div class="text-wrap">
          <div class="tit">区块链+供应链金融</div>
          <div class="des">供应链全流程透明化</div>
          <div class="des">打破传统操作流程</div>
          <div class="des">提升核心企业授信规模</div>
          <div class="des">增强再融资能力</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        vedioCanPlay: false,
        fixStyle: ''
      }
    },
    methods: {
      canplay(){
        this.vedioCanPlay = true;
      }
    },
  }
</script>

<style lang="less" scoped>
.banner{
  width:100vw;
  height:100vh;
  overflow: hidden;
  position: relative;
  .video-wrap{
    position: relative;
    width:100vw;
    min-height:100vh;
    background:#000;
    overflow:hidden;
  }
  .video{
    width:100vw;
    position: relative;
    overflow: hidden;
  }
  .inner{
    width:100vw;
    height:100%;
    margin:0 auto;
    position: absolute;
    overflow: hidden;
    top:0;
    left:0;
    z-index:2;
    margin:0 auto;
    background: rgba(0, 0, 0, 0.6);
    .text-wrap{
      position: absolute;
      top:30%;
      left:0;
      width:100%;
      height:100%;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 600;
        font-size: 80px;
        line-height: 56px;
        text-align: center;
        color: #FFF;
        padding-top:60px;
        padding-bottom:60px;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        color: #fff;
      }
      .agin-left{
        text-align: left;
      }
    }
  }
}
@media screen and (min-width: 1920px) {
  .banner {
    .inner{
      .text-wrap{
        .tit{
          font-size:140px;
          padding-bottom:80px;
        }
        .des{
          font-size:40px;
          line-height: 80px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>